

import Vue from 'vue'
import FastClick from 'fastclick'
import App from './App'
import qs from 'qs'

import store from '@/vuex/store'
import router from '@/router'
import AjaxPlugin from '@/utils/request'
import api from '@/utils/api'
import utils from '@/utils/utils'
import config from '@/utils/config'
import ConfigPlugin from 'vux/src/plugins/config/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import cookie from 'vux/src/tools/cookie/index.js'

import wx from 'weixin-js-sdk'
import Vconsole from 'vconsole'


import 'vant/lib/index.css';
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);


Vue.use(DatetimePlugin)
Vue.use(LoadingPlugin)
Vue.use(AjaxPlugin)
Vue.use(ToastPlugin, {
position: 'middle'
})
Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX'
})

Vue.prototype.$api = api
Vue.prototype.$wx = wx
Vue.prototype.$cookie = cookie
Vue.prototype.$utils = utils
Vue.prototype.$config = config

if (!location.href.includes('yaoqingwo.com') && !location.href.includes('choiceedu.com')) {
let vConsole = new Vconsole()
}

let ajax = AjaxPlugin.$http.create({
baseURL: AjaxPlugin.$http.defaults.baseURL,
});
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: '', // 必填，公众号的唯一标识
timestamp: '', // 必填，生成签名的时间戳
nonceStr: '', // 必填，生成签名的随机串
signature: '', // 必填，签名，见附录1
jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'getLocalImgData', 'uploadImage', 'downloadImage', 'hideMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem']
})

wx.onMenuShareTimeline({
title: '1231', // 分享标题
desc: '1111', // 分享描述
link: `${window.location.protocol}//${window.location.host}`, // 分享链接
imgUrl: 'https://choice-oss.oss-cn-shenzhen.aliyuncs.com/laravel/mobile/share-logo.png', // 分享图标
type: '', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function () {
console.log('share', `${window.location.protocol}//${window.location.host}`)



}
});

wx.onMenuShareAppMessage({
title: '1231', // 分享标题
desc: '1111', // 分享描述
link: `${window.location.protocol}//${window.location.host}`, // 分享链接
imgUrl: 'https://choice-oss.oss-cn-shenzhen.aliyuncs.com/laravel/mobile/share-logo.png', // 分享图标
type: '', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function () {
console.log('share')



}
});
wx.ready(function () {

wx.onMenuShareTimeline({
title: '1231', // 分享标题
desc: '1111', // 分享描述
link: `${window.location.protocol}//${window.location.host}`, // 分享链接
imgUrl: 'https://choice-oss.oss-cn-shenzhen.aliyuncs.com/laravel/mobile/share-logo.png', // 分享图标
type: '', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function () {
console.log('share', `${window.location.protocol}//${window.location.host}`)



}
});

wx.onMenuShareAppMessage({
title: '1231', // 分享标题
desc: '1111', // 分享描述
link: `${window.location.protocol}//${window.location.host}`, // 分享链接
imgUrl: 'https://choice-oss.oss-cn-shenzhen.aliyuncs.com/laravel/mobile/share-logo.png', // 分享图标
type: '', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function () {
console.log('share')



}
});
})















router.afterEach(()=>{
document.title='Choice'
})
Vue.config.productionTip = false

/* eslint-disable no-new */
let vue = new Vue({
router,
store,
render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js